const validateAnswer = function (errors, vm, showTip) {
  const { optionList, value, answerConfig } = this
  if (answerConfig.requireInd === '1') {
    if (!value) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  }
  if (!value) {
    return !errors.length
  }

  // 其他请注明选项
  const otherItem = optionList.find(item => item.id === value && item.type === 'other')
  if (otherItem && answerConfig.otherRequireInd === '1' && (!otherItem.otherValue || (otherItem.otherValue && !otherItem.otherValue.trim()))) {
    errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
  }

  return !errors.length
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/RadioBox/answerValidate.js